export default "__VITE_ASSET__1c387262__"